<template>
    <div class="home">

      <div class="slideshow">
        <el-carousel :interval="5000" trigger="click" height="559px">
          <el-carousel-item v-for="item in slideshowList" :key="item.id">
            <img :src="item.ossPath" width="100%" height="559" @click="skip(item.link)">
          </el-carousel-item>
        </el-carousel>
      </div>

      <div class="locationNav">
        <div class="easilyNav">
            <div class="singleNav clearfix"
              v-for="(item,index) in easilyNavList"
              :key="index"
              @click="locationGoPage(item.path,)"
              @mouseenter="mouseEnter(item.index)"
              @mouseleave="mouseLeave"
              :class="{ itemHover:itemHoverIndex === item.index,
                        itemRadioHead:item.index==='1',
                        itemRadioFoot:item.index === '5'}">
                <div class="logo fl">
                  <img :src="item.url" alt="">
                </div>
                <div class="fl">
                  <p class="title">{{item.title}}</p>
                  <p class="englishTitle">{{item.EnglishTitle}}</p>
                </div>
            </div>
        </div>
      </div>

      <!-- 通知 -->
      <div class="notice flex-row">
          <p>
            <img src="@/assets/home/notice.png" alt="">
            <span>通知公告 </span>
            <span class="notice-details"
              @click="locationGoPage('/informDetail')">
                {{noticeList.title}}
                <span class="notice-time">{{noticeList.infoDate}}</span>
            </span>
          </p>
        <el-button class="moreBtn" type="text" @click="locationGoPage('/inform')">+ 更多</el-button>
      </div>

      <!-- 资讯 -->
      <div  class="information">
        <div class="titles-box">
          <div class="titles-world">
            <p class="titles-bigWord">资讯动态</p>
            <p>INFORMATION</p>
          </div>
          <el-divider></el-divider>
          <button class="titlesBtn" @click="locationGoPage('/information')">+ 更多</button>
        </div>

        <div class="information-draw">
          <div class="information-item"
            v-for="(item,index) in informationLIstanbul"
            :key="index"
            :class="{ noMargin:index === 3}"
            @click="locationGoPage('/informationDetail',item.id)">
            <img :src="item.thumbnail ? item.thumbnail : defaultImg" alt="">
            <p class="information-time">{{item.publishTime || ''}}</p>
            <p class="information-title">
              <!-- {{item.title}} -->
              <a :title="item.title">{{item.title}}</a>
            </p>
          </div>
        </div>
      </div>

      <!-- <div class="activity">
        <div class="activity-word">
          <div class="activity-box">
            <p class="activity-ChWord">活动赛事</p>
            <p>ACTIVITY</p>
          </div>
          <el-divider></el-divider>
        </div>

        <div class="activity-pic"> -->
          <!-- 原始 -->
          <!-- <el-carousel class="slideshow-activity"
            :interval="4000"
            indicator-position="outside"
            type="card"
            height="285px">
            <el-carousel-item class="img-styl"
              v-for="item in activitySlideshowList"
              :key="item.id"
              >
              <img :src="item.url" width="766px" height="485px" @click="locationGoPage(item.path)">
            </el-carousel-item>
          </el-carousel> -->

          <!-- <el-carousel :interval="40000"
            type="card"
            indicator-position="outside"
            height="520px"
            class="slideshow-activity">
            <el-carousel-item class="img-styl"
              v-for="item in activitySlideshowList"
              :key="item.id">
              <img :src="item.url" height="480px" @click="locationGoPage(item.path)">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div> -->

      <!-- <div class="hatchBase-title">
        <div class="title-box" @click="locationGoPage('/basePage')">
          <p class="big-title">孵化基地风采</p>
          <p>CREATIVE BASE</p>
          <el-divider></el-divider>
          <button class="content-btn">+ 查看</button>
        </div>
      </div> -->

      <div class="abroadGarden">
        <div class="titles-box abroadGarden-world">
          <div class="titles-world">
            <p class="titles-bigWord">孵化基地</p>
            <p>PARK</p>
          </div>
          <el-divider></el-divider>
          <button class="titlesBtn" @click="locationGoPage('/basePage')">+ 更多</button>
        </div>

        <div class="abroadGarden-draw">
          <div class="abroadGarden-bigImg">
            <img style="cursor: pointer;"
              v-if="abroadGardenBigImg"
              :src="!abroadGardenBigImg.basementScene ? defaultImg: abroadGardenBigImg.basementScene[0]"
              @click="locationGoPage('/gardenDetail',abroadGardenBigImg.basementBasicId)">
            <p v-if="abroadGardenBigImg">{{abroadGardenBigImg.name}}</p>
          </div>

          <ul class="abroadGarden-smlImg">
            <template v-for="(item,index) in abroadGardenList">
              <li class="smlImg"
              :key="index">
                <img style="cursor: pointer;"
                  :src="!item.basementScene ? defaultImg: item.basementScene[0]"
                   @click="locationGoPage('/gardenDetail',item.basementBasicId)">
                <p>{{item.name}}</p>
              </li>
            </template>
          </ul>
        </div>
      </div>

      <!-- <div class="dfigureGarden">
        <div class="dfigureGarden-title">
          数字园区展示
        </div>
        <div class="dfigureSlideshow">
            <el-carousel class="dfigureImg" trigger="click" indicator-position="outside" height="696px">
              <el-carousel-item v-for="item in dfigureSlideshow" :key="item.id">
                <img style="cursor: pointer;" :src="item.thumbnail ?item.thumbnail : defaultImg" width="100%" @click='checkVideoFun(item.video)'>
                <h3 style="cursor: pointer;" class="dfigureImg-title" @click="goLink(item.website)">{{ item.name }}</h3>
              </el-carousel-item>
            </el-carousel>
        </div>

        <div class='mask' v-if='videoState == true' @click='masksCloseFun'></div>
        <div class="videomasks" v-if="videoState == true">
            <video :src='videoSrc' controls='controls' autoplay>
            </video>
        </div>
      </div> -->

      <!-- <div class="abroadCompany-title">
        <div class="title-box" @click="locationGoPage('/firm')">
          <p class="big-title">留创企业一览</p>
          <p>ENTERPRISES FOR OVERSEAS STUDENTS</p>
          <el-divider></el-divider>
          <button class="content-btn">+ 查看</button>
        </div>
      </div> -->

      <div class="abroadCompanySum">
        <!-- <div class="titles-box service-world">
          <div class="titles-world">
            <p class="titles-bigWord">优选服务</p>
            <p>SERVICE</p>
          </div>
          <el-divider></el-divider>
        </div> -->

        <!-- <p class="service-img" @click="goLink(serveImg.url)">
          <img :src="serveImg.picture ? serveImg.picture : defaultImg" alt="">
        </p> -->

        <div class="titles-box service-world">
          <div class="titles-world">
            <p class="titles-bigWord">政策法规</p>
            <p>POLICY</p>
          </div>
          <el-divider></el-divider>
          <button class="titlesBtn" @click="locationGoPage('/policy')">+ 更多</button>
        </div>

        <div class="policy">
          <!-- <div class="policy-first" @click="locationGoPage('/policyDetail',policyFirst)">
            <img :src="policyFirst.thumbnail ? policyFirst.thumbnail : defaultImg" alt="">
            <p class="flex-row">
              <a :title="policyFirst.title">{{policyFirst.title  | limitWordText(25)}}</a>
              <span v-if="policyFirst.infoDate">{{ policyFirst.infoDate == null? 'null':policyFirst.infoDate.split(' ')[0]}}</span>
            </p>
          </div> -->
          <div v-if="policyFirst.policyType === '国家政策' "
            style="background-color:#d56c17"
            class="new-policy-first"
            @click="locationGoPage('/policyDetail',policyFirst.id)">
              <p class="new-tit-style" style="width: 92%;display: block;margin: 0 auto;">{{policyFirst.title}}</p>
              <p class="new-code-style" >{{policyFirst.fileCode}}</p>
          </div>
          <div v-if="policyFirst.policyType === '地方政策' "
            style="background-color:#0267da"
            class="new-policy-first"
            @click="locationGoPage('/policyDetail',policyFirst.id)">
              <p class="new-tit-style" style="width: 92%;display: block;margin: 0 auto;" >{{policyFirst.title}}</p>
              <p class="new-code-style" >{{policyFirst.fileCode}}</p>
          </div>
          <div class="policy-list">
            <div class="policy-item"
              v-for="(item,index) in policyList"
              :key="index"
              @click="locationGoPage('/policyDetail',item.id)">
              <!-- <p><img :src="item.thumbnail ? item.thumbnail : defaultImg" alt=""></p> -->
              <div v-if="item.policyType === '国家政策' " class="new-style" style="background-color:#d56c17">
                <p class="new-tit-style" >{{item.title}}</p>
                <p class="new-code-style" >{{item.fileCode}}</p>
              </div>
              <div v-if="item.policyType === '地方政策' " class="new-style" style="background-color:#0267da">
                <p class="new-tit-style" >{{item.title}}</p>
                <p class="new-code-style">{{item.fileCode}}</p>
              </div>
              <div class="policy-content">
                <p>{{item.title}}</p>
                <p class="policy-time" v-if="item.infoDate">{{ item.infoDate == null? 'null':item.infoDate.split(' ')[0]}}</p>
                <p class="policy-article twoLine-omit" >{{item.fileCode}}</p>
                <!-- <p class="policy-article twoLine-omit" >{{delHtmlTag(item.detail)}}</p> -->
                <!-- <p class="policy-article twoLine-omit" >{{removeTAG(item.detail,20)}}</p> -->
              </div>
            </div>
          </div>
        </div>

        <div class="titles-box service-world">
          <div class="titles-world">
            <!-- <p class="titles-bigWord">电子杂志</p> -->
            <p class="titles-bigWord">杂志年鉴</p>
            <p>E-ZINE</p>
          </div>
          <el-divider></el-divider>
          <button class="titlesBtn btnColor" @click="locationGoPage('/magazine')">+ 更多</button>
        </div>

        <div class="E-Zine">
          <div class="E-Zine-item"
            v-for="(item,index) in EZine"
            :key="index"
            @click="openPdf(item.ossPath)"
            :class="{ noMargin:index === 3}">
              <img :src="item.icon" alt="">
              <div class="periodicals">
                <span>{{item.intro | limitWordText(16)}}</span>
              </div>
          </div>
        </div>
      </div>

      <return-top></return-top>
    </div>
</template>

<script>
import ReturnTop from '../components/returnTop.vue'
import mixins from '@/utils/mixin'
// import pdf from 'vue-pdf'
export default {
  name: 'home',
  mixins: [mixins],
  props: {

  },
  components: {
    ReturnTop
    // pdf
  },
  data () {
    return {
      defaultImg: require('@/assets/home/lostImg.png'),
      userType: '', // 用户类型
      slideshowList: [], // 轮播图列表
      // 便捷标签
      easilyNavList: [
        {
          index: '1',
          title: '海创大赛',
          path: '/HCMegagame',
          EnglishTitle: 'Competition',
          url: require('@/assets/home/competition.png')
        },
        {
          index: '2',
          title: '网络年会',
          path: '/webAnnualMeeting',
          EnglishTitle: 'Annual Meeting',
          url: require('@/assets/home/AnnualMeeting.png')
        },
        {
          index: '3',
          title: '企业评选',
          path: '/firmElect',
          EnglishTitle: 'Enterprise Selection',
          url: require('@/assets/home/EnterpriseSelection.png')
        },
        {
          index: '4',
          title: '通知公告',
          path: '/inform',
          EnglishTitle: 'Inform Announcement',
          url: require('@/assets/home/EnterpriseService.png')
        },
        {
          index: '5',
          title: '园区管理',
          path: '/surveyInfo',
          EnglishTitle: 'Park Managemenet',
          url: require('@/assets/home/gardenManage.png')
        }
      ],
      itemHoverIndex: null, // 鼠标移入索引
      noticeList: {}, // 通知公告列表
      informationLIstanbul: [], // 资讯动态列表
      // 赛事轮播图
      activitySlideshowList: [
        {
          id: '1',
          path: '/HCMegagame',
          url: require('@/assets/home/activitySlideshow1.png')
        },
        {
          id: '3',
          path: '/webAnnualMeeting',
          url: require('@/assets/home/activitySlideshow3.png')
        },
        {
          id: '2',
          path: '/firmElect',
          url: require('@/assets/home/activitySlideshow2.png')
        }
      ],

      abroadGardenBigImg: {}, // 留创风景展示大图
      abroadGardenList: [], // 留创园区展览图

      dfigureSlideshow: [], // 数字园区视频缩略图
      videoSrc: '', // 数字园区视频
      videoState: false,
      dialogVisible: false, // 视频会话框

      serveImg: {}, // 优选服务

      // 政策法规
      policyFirst: {},
      policyList: [],
      currentPage: 1,
      // 电子杂志
      EZine: []
    }
  },
  computed: {

  },
  created () {
    this.getUserType() // 加载用户类型
    this.getHomeInfo() // 加载首页数据信息
  },
  mounted () {
    this.$parent.activeIndex = '1'
  },
  methods: {
    removeTAG (str, len) {
      return str.replace(/<[^>]+>/g, '')
    },

    // 用户类型加载
    getUserType () {
      if (localStorage.getItem('tokenStr')) { this.userType = localStorage.getItem('userType'); return false }
      if (sessionStorage.getItem('tokenStr')) { this.userType = sessionStorage.getItem('userType'); return false }
    },
    // 鼠标移入移出动画
    mouseEnter (index) {
      this.itemHoverIndex = index
    },
    mouseLeave () {
      this.itemHoverIndex = null
    },

    // 用户访问权限页面跳转
    locationGoPage (path, item) {
      this.$bus.$emit('changeNav', '2')
      if (this.userType === 'common' && path === '/surveyInfo') {
        this.$message.error('您不是园区用户，禁止访问！')
      } else if (path === '/inform') {
        this.$bus.$emit('changeNav')
        this.$router.push(path)
      } else if (path === '/informDetail') {
        // sessionStorage.setItem('detailData', JSON.stringify(this.noticeList))
        // this.$router.push(path)
        this.$bus.$emit('changeNav')
        this.$router.push({ path: path, query: { id: this.noticeList.id } }) // 跳转通知详情
        // console.log(this.noticeList.id)
      } else if (path === '/informationDetail') {
        // sessionStorage.setItem('detailData', JSON.stringify(item))
        // this.$router.push(path)
        this.$router.push({ path: path, query: { id: item } }) // 跳转资讯详情
      } else if (path === '/gardenDetail') {
        this.$router.push({
          path: path,
          query: { id: item }
        })
      } else if (path === '/policyDetail') {
        // sessionStorage.setItem('detailData', JSON.stringify(item))
        // this.$router.push(path)
        this.$router.push({ path: path, query: { id: item } }) // 跳转政策详情
      } else if (path === '/serve') {
        this.getDetail()
        setTimeout(() => {
          if (this.serveUrl === null) { return }
          if (this.serveUrl.indexOf('https://') !== -1) {
            this.serveUrl.replace('https://', 'http://')
            window.open(this.serveUrl)
          } else if (this.serveUrl.indexOf('http://') !== -1) {
            window.open(this.serveUrl)
          } else {
            window.open('http://' + this.serveUrl)
          }
        }, 500)
      } else if (path === '/HCMegagame') {
        setTimeout(() => {
          window.open('http://www.oseccn.com/')
        }, 500)
      } else {
        this.$router.push(path)
      }
    },
    async getDetail () {
      try {
        const res = await this.$get(this.$url.serve.tbService)
        const { code, msg, data } = res.data
        if (code === 200) {
          // this.detail = res.data.data
          this.serveUrl = data.url
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 获取首页渲染数据
    async getHomeInfo () {
      try {
        const res = await this.$get(this.$url.home.indexInfo)
        const { code, msg, data } = res.data

        console.log('data_________________________')
        console.log(data)

        if (code === 200 && data) {
          this.slideshowList = data.rollingPictures.reverse() || [] // 轮播图

          this.noticeList = data.tbInnerInfo || [] // 通知

          this.informationLIstanbul = data.tbOuterInfo || [] // 资讯

          this.abroadGardenList = data.tbBasementsScene || [] // 留创园区
          this.abroadGardenBigImg = this.abroadGardenList.shift()// 留创园区首图

          // this.dfigureLink = data.tbBasementsDigital
          this.dfigureSlideshow = data.tbBasementsDigital.filter((item) => {
            return item.showIndexDigital !== null
          }).sort((item01, item02) => {
            return item01.showIndexDigital - item02.showIndexDigital
          }) || [] // 数字园区

          this.serveImg = data.tbService || []// 优选服务

          // this.policyList = data.tbPolicies || []
          if (data.tbPolicies !== []) {
            this.policyList = data.tbPolicies
            this.policyList.forEach((item) => {
              item.publishTime = item.publishTime == null ? 'null' : item.publishTime.split(' ')[0]
            })
            this.policyFirst = this.policyList.shift()// 政策大图
          } else {
            this.policyList = []
          }
          // this.policyList.forEach((item) => {
          //   item.publishTime = item.publishTime.split(' ')[0]
          // })
          // this.policyFirst = this.policyList.shift()// 政策大图
          this.EZine = data.associationMagazine.splice(0, 4) // 电子杂志
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },

    // 优选服务跳转
    goLink (url) {
      if (url === null) { return }

      if (url.indexOf('https://') !== -1) {
        url.replace('https://', 'http://')
        window.open(url)
      } else if (url.indexOf('http://') !== -1) {
        window.open(url)
      } else {
        window.open('http://' + url)
      }
    },

    // 跳转链接
    skip (url) {
      if (url === null) { return }
      // console.log(url)
      if (url && url.indexOf('https://') !== -1) {
        url.replace('https://', 'http://')
        window.open(url)
      } else if (url && url.indexOf('http://') !== -1) {
        window.open(url)
      } else {
        window.open('http://' + url)
      }
      window.open(url)
    },
    // 弹出层播放视频
    checkVideoFun (videos) {
      this.videoState = true
      this.videoSrc = videos
    },
    masksCloseFun () {
      this.videoState = false
    },
    // 打开pdf
    openPdf (url) {
      window.open(url)
    }
  },
  destroyed () {
    // 销毁浏览器监听回退
    window.removeEventListener('popstate', this.goback, false)// false阻止默认事件
  }
}
</script>

<style scoped lang="less">
.home{
  width: 100%;
  min-height: 100vh;
  font-size: 16px;
}

.slideshow{
  position: relative;
  z-index: 10;
  background-color:#fff;
  cursor: pointer;
}
/deep/.el-carousel__arrow{
  width: 54px;
  height: 54px;
  font-size: 0;
}
/deep/.el-carousel__arrow--left{
  left: 60px;
  background: url('~@/assets/home/left-btn.png') no-repeat;
}
/deep/.el-carousel__arrow--right{
  right: 60px;
  background: url('~@/assets/home/right-btn.png') no-repeat;
}
// 快捷通道
.locationNav{
  width: 1200px;
  height: 122px;
  margin: 0px auto;
  // background-color: rgb(240, 198, 221);
  position: relative;
  cursor: pointer;
  .easilyNav{
    position: absolute;
    top: -60px;
    z-index: 99;
    width: 1200px;
    height: 122px;
    margin: 0px auto;
    box-shadow: 0px 2px 10px 0px rgba(164, 164, 164, 0.5);
    border-radius: 10px;
    .singleNav{
      display: inline-block;
      box-sizing: border-box;
      padding: 31px 0 0 26px;
      width: 240px;
      height: 122px;
      line-height: 20px;
      text-align: center;
      background-color: #fff;
      .logo{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 66px;
        height: 66px;
        box-sizing: border-box;
        margin-right: 10px;
        vertical-align: middle;
        border-radius: 50px;
        background-color: #f9f9f9;
      }
      .title{
        font-size: 16px;
        font-weight: 600;
        margin-top: 13px;
        text-align: left;
      }
      .englishTitle{
        font-size: 12px;
        color: #b8bfc5;
      }
    }
  }
}
// 通知
.notice{
  width: 1200px;
  height: 33px;
  line-height: 33px;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 0 18px;
  background: #3056d9;
  border-radius: 20px;
  color: #fff;
  cursor: pointer;
  img {
    vertical-align: middle;
    margin-right: 10px;
  }
  .notice-details{
    display: inline-block;
    margin: 0 15px 0 30px;
    .notice-time{
      display: inline-block;
      margin-left: 15px;
    }
  }
  .moreBtn{
    color: #fff;
    font-size: 16px;
  }
}

//资讯动态
.information{
  width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  overflow: hidden;
  .information-draw{
    box-sizing: border-box;
    margin: 22px 0 40px 0 ;
    // overflow: hidden;

    .information-item{
      display: inline-block;
      width: 283px;
      height: 310px;
      box-sizing: border-box;
      background-color: #fff;
      padding: 14px;
      margin-right: 22px;
      box-shadow: 0px 4px 14px 0px rgba(206, 206, 206, 0.5);
      border-radius: 2px;
      overflow: hidden;
      cursor: pointer;
      img{
        width: 255px;
        height: 179px;
      }
      .information-time{
        color: #CECECE;
        box-sizing: border-box;
        // line-height: 1.5;
        margin: 11px 0 10px 0;
      }
      .information-title{
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2; //显示行数
        -webkit-box-orient: vertical;
      }
    }
  }
}

// 标题
.titles-box{
  width: 1200px;
  display: flex;
  box-sizing: border-box;
  margin: 23px auto 0;
  line-height: 26px;
  .titles-world{
    box-sizing: border-box;
    margin-right: 22px;
    width: 150px;
    .titles-bigWord{
      font-size: 26px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
    }
  }
  .titlesBtn{
    width: 120px;
    height: 35px;
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #898B91;
    margin: 6px 0 0 22px;
    cursor: pointer;
  }
}
// 活动赛事
.activity{
  width: 100%;
  height: 805px;
  background: url('~@/assets/home/activity-bg.png') no-repeat;
  background-size: cover;
  overflow: hidden;
  .activity-word{
    display: flex;
    width: 1200px;
    height: 60px;
    margin: 40px auto 42px;
    box-sizing: border-box;
    .activity-box{
      width: 130px;
      line-height: 28px;
      box-sizing: border-box;
      margin-right: 10px;
      .activity-ChWord{
        font-size: 26px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
      }
    }
  }
  .activity-pic{
    /*width: 1600px;*/
    width: 1200px;
    height: 580px;
    margin: 0 auto;
    box-sizing: border-box;
    .slideshow-activity{
      /deep/.el-carousel__item{
        background-color: lightblue;
      }
      /deep/.el-carousel__item--card {
          width: 50%;
          // width: 766px;
      }
      /deep/.is-active{
        width: 65%;
        transform: translateX(210px) scale(1) !important;
      }
      /deep/.el-carousel__button{
        width: 46px;
        height: 9px;
        border-radius: 3px;
        margin-top: 45px;
        background-color:  #3056D9;
      }
      .img-styl{
        box-sizing: border-box;
        border: 20px solid #fff;
        img{
          /*width: 766px;*/
          width: 100%;
          height: 480px;
        }
      }
      /deep/.el-carousel__indicators li{
        width: 50px !important;
        transform:none !important;
      }
    }
  }
}

// 孵化基地title
.hatchBase-title{
  background: url('~@/assets/home/hatchBase.png') no-repeat;
  background-size: cover;
}

// 基地企业title
.hatchBase-title,
.abroadCompany-title{
  width: 100%;
  height: 286px;
  .title-box{
    display: flex;
    flex-flow:column ;
    justify-content: center;
    align-items: center;
    width: 353px;
    height: 286px;
    margin: 0 auto;
    color: #fff;
    line-height: 20PX;
    .big-title{
      font-size: 30px;
      margin-bottom: 15px;
    }
    .content-btn{
      width: 120px;
      height: 40px;
      border-radius: 2px;
      border: 1px solid #FFFFFF;
      color: #fff;
      font-size: 16px;
      background-color: transparent;
      cursor: pointer;
    }
  }
}

// 留创园区
.abroadGarden{
  width: 100%;
  height: 620px;
  background: url('~@/assets/home/abroadGarden.png') no-repeat;
  background-size: cover;
  overflow: hidden;
  .abroadGarden-world{
    margin-top: 40px;
  }
  .abroadGarden-draw{
    display: flex;
    width: 1200px;
    height: 100%;
    margin: 28px auto 0;
    word-wrap:break-word;
    .abroadGarden-bigImg{
      width: 604px;
      height: 471px;
      img{
        width: 604px;
        height: 421px;
      }
      p{
        margin: 17px 0 0 197px;
      }
    }
    .abroadGarden-smlImg{
      width: 595px;
      height: 471px;
      word-wrap: break-word;
      word-break: break-all;
      .smlImg{
        width: 262px;
        height: 233px;
        display: inline-block;
        box-sizing: border-box;
        margin-left: 35px;
        overflow: hidden;
        img{
          width: 262px;
          height: 182px;
        }
        p{
          margin: 16px 0 0 14px ;
        }
      }
    }
  }
}

// 数字园区
.dfigureGarden{
  width: 100%;
  height: 934px;
  background: url('~@/assets/home/dfigureGarden.png') no-repeat;
  background-size: cover;
  .dfigureGarden-title{
    width: 190px;
    height: 55px;
    line-height: 55px;
    font-size: 28px;
    font-weight: 600;
    border-bottom: 5px solid #3056D9;
    border-radius: 3px;
    margin: 30px auto 25px;
    text-align: center;
  }
  .dfigureSlideshow{
    position: relative;
    z-index: 10;
    width: 1200px;
    margin: 40px auto 0;
    // background-color: wheat;
    .dfigureImg{
      // position: relative;
      color: #fff;
      img {
        width: 1147px;
        height: 642px;
        border: 27px solid #94c6ff;
        border-radius: 5px;
        position: absolute;
        z-index: 20;
      }
      .dfigureImg-title{
        position: absolute;
        z-index: 99;
        bottom: 27px;
        left: 27px;
        width: 1147px;
        height: 70px;
        line-height: 70px;
        // font-size: 16px;
        text-decoration: underline;
        box-sizing: border-box;
        padding-left: 33px;
        background-color:rgba(0, 0, 0, 0.6);
      }
      .video-style{
        width: 1200px;
        height: 500px;
      }
      /deep/.el-carousel__button{
        width: 46px;
        height: 9px;
        border-radius: 3px;
        margin-top: 40px;
        background-color:  #3056D9;
      }
    }
  }
}
.mask{
  position:fixed;
  top:0;
  left:0;
  bottom:0;
  right:0;
  z-index:120;
  background-color: #000000;
  opacity: 0.6;
}
// 内容层 z-index要比遮罩大，否则会被遮盖
.videomasks{
  min-width: 1400px;
  position: fixed;
  left: 50%;
  top: 50%;
  z-index: 150;
  transform: translate(-50%,-50%);
}
.videomasks video{
  width: 100%;
  height: 600px;
}

// 留创企业title
.abroadCompany-title{
  background: url('~@/assets/home/abroadCompany.png') no-repeat;
  background-size: cover;
}

// 留创企业总览
.abroadCompanySum{
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;

  // 优选服务
  .service-world{
    margin:70px 0 34px ;
    .btnColor{
      background-color: #3056D9;
      color: #fff;
    }
  }
  .service-img{
    width: 1200px;
    height: 250px;
    // background-image: url('~@/assets/home/service.png');
    background-color: #ccc;
    cursor: pointer;
    img{
      width: 1200px;
      height: 250px;
    }
  }
  // 政策法规
  .policy{
    display: flex;
    width: 1200px;
    height: 403px;
    overflow: hidden;
    .new-policy-first{
      width: 580px;
      height: 403px;
      box-sizing: border-box;
      padding: 50px 0;
      display: flex;
      flex-flow: column;
      justify-content: space-around;
      align-items: center;
      position: relative;
      cursor: pointer;
      color: #fff;
      font-size: 26px;
    }
    .policy-first{
      width: 580px;
      height: 403px;
      position: relative;
      cursor: pointer;
      img{
        width: 580px;
        height: 403px;
      }
      p{
        position: absolute;
        bottom: 0;
        width: 580px;
        height: 53px;
        // line-height: 53px;
        padding: 0 15px;
        box-sizing: border-box;
        background-color:rgba(0, 0, 0, 0.6);
        color: #fff;
      }
    }
    .policy-list{
      box-sizing: border-box;
      margin-left: 21px;
      .policy-item {
        display: flex;
        width: 100%;
        height: 120px;
        font-size: 16px;
        margin-bottom: 21px;
        img{
        width: 176px;
        height: 120px;
        }
        cursor: pointer;
        .new-style{
          display: flex;
          flex-flow: column;
          justify-content: space-around;
          align-items: center;
          width: 176px;
          height: 120px;
          box-sizing: border-box;
          padding: 20px 10px;
          // padding: 0 10px;
          font-size: 12px;
          .new-tit-style{
            width:156px;
            color:#fff;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2; //显示行数
            -webkit-box-orient: vertical;
          }
          .new-code-style{
            color:#fff;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 1; //显示行数
            -webkit-box-orient: vertical;
          }
        }
      }
      .policy-content{
        margin:10px 0 0 13px;
        .policy-article,
        .policy-time{
          color: #898B91;
          margin-top: 5px;
        }
      }
    }
  }
  // 电子杂志
  .E-Zine{
    width: 1200px;
    height: 420px;
    box-sizing: border-box;
    margin-bottom: 115px;
    overflow: hidden;
    .E-Zine-item{
      position: relative;
      width: 270px;
      height: 363px;
      display: inline-block;
      cursor: pointer;
      // display: flex;
      // width: 270px;
      // height: 363px;
      // background-color: #94c6ff;
      margin-right: 40px;
      img {
        width: 270px;
        height: 363px;
        box-shadow: 0px 4px 14px 0px rgba(206, 206, 206, 0.5);
        border-radius: 1px;
      }
      .periodicals{
        position: absolute;
        bottom: -30px;
        left: 25px;
        width: 223px;
        height: 45px;
        line-height: 45px;
        font-size: 16px;
        background: #FFFFFF;
        box-shadow: 0px 4px 23px 0px rgba(0, 0, 0, 0.24);
        border-radius: 31px;
        text-align: center;
        /deep/.el-divider--vertical{
          width: 2px;
          height: 18px;
          margin: 0 10px;
          background-color: #999;
        }
      }
    }
  }
}

.itemHover{
  background: linear-gradient(180deg, #3056D9 0%, #1076EC 100%);
  box-shadow: 0px 2px 10px 0px rgba(164, 164, 164, 0.5);
  color: #ffffff!important;
}
.itemRadioHead{
  border-radius: 10px 0px 0px 10px;
}
.itemRadioFoot{
  border-radius: 0px 10px 10px 0px;
}
.noMargin{
  margin-right: 0 !important;
}
</style>
